module.exports = __webpack_public_path__ + "img/app-store.8a9be425.svg";